import { NavLink } from "react-router";

import { useEffect } from "react";

import appAjax from '../helpers/ajax';
import appUi from '../helpers/ui';

function QrScanner() {
    let jbScanner = null;
    let scannerParentElement = null;
    let userMedia = null;

    const onQRCodeScanned = (scannedText) => {
        jbScanner.stopScanning();
        appUi.uiAlert(scannedText, null, 'Scanned', 'success');
        jbScanner.resumeScanning();
    };

    const provideVideo = () => {
        var n = navigator;
    
        if (n.mediaDevices && n.mediaDevices.getUserMedia)
        {
            return n.mediaDevices.getUserMedia({
                video: {
                    facingMode: "environment"
                },
                audio: false
            });
        }
    
        // _web_ui_htmlalert('Your browser does not support getUserMedia. Please use other browser or update your browser.',
        //     null, 'Error', 'error');
        
        return Promise.reject('Your browser does not support getUserMedia');
    }

    const stopVideo = () => {
        if (jbScanner) {
            jbScanner.stopScanning();
            jbScanner.removeFrom(scannerParentElement);
        }
        jbScanner = null;
    };

    const onLoad = () => {
        if (!appAjax.JsQRScanner) {
            setTimeout(onLoad, 1000);
            return;
        }

        if (!jbScanner) {
            //create a new scanner passing to it a callback function that will be invoked when
            //the scanner succesfully scan a QR code
            jbScanner = new window.JsQRScanner(onQRCodeScanned, provideVideo);
            //var jbScanner = new JsQRScanner(onQRCodeScanned, provideVideo);
            //reduce the size of analyzed image to increase performance on mobile devices
            jbScanner.setSnapImageMaxSize(500);
            jbScanner.setScanInterval(500);
            scannerParentElement = document.getElementById("scanner");
            if(scannerParentElement)
            {
                //append the jbScanner to an existing DOM element
                jbScanner.appendTo(scannerParentElement);
            }        
        }
    };

    useEffect(() => {
        onLoad();
        
        return () => {
            stopVideo();
        }
    }, []);

    return (
    <div className="container">
        <div className="row">
            <div className="col-lg-6 offset-lg-3">
                <div className="card">
                    <div className="card-header">
                        <h2>Scanner</h2>
                    </div>
                    <div className="card-body">
                        <div id="scanner" className="mb-3" style={{height: "400px", backgroundColor: "#EEE", border: "solid 1px #AAA", overflow: "hidden"}}></div>
                        <NavLink to="/" className="btn btn-primary btn-block"><i className="fa fa-chevron-left"></i> Back</NavLink>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    );
}

export default QrScanner;
